export const validatePolicySelectedOptions = ({
  name,
  paymentPolicyCode,
  returnsPolicyCode,
  shippingPolicyCode,
}) =>
  name !== '' && paymentPolicyCode !== '' && returnsPolicyCode !== '' && shippingPolicyCode !== '';

export const isBtnDisabled = (cloneOptions, currentOptions) =>
  JSON.stringify(cloneOptions) === JSON.stringify(currentOptions) ||
  !cloneOptions ||
  !validatePolicySelectedOptions(currentOptions);
